import get from 'lodash/get';
import { sentryCaptureException } from './sentry/sentryMethods';

export class HttpError extends Error {
  constructor(err) {
    super(err.message);
    this.name = 'HTTP ERROR';
  }
}

export function trackHttpError(err) {
  const apiURL = get(err, 'response.config.url');
  const reqData = get(err, 'response.config.data');
  const status = get(err, 'response.status');
  const response = get(err, 'response.data.data');

  sentryCaptureException(new HttpError(err), {
    extra: {
      API_URL: apiURL,
      REQUEST_PAYLOAD: reqData,
      STATUS_CODE: status,
      RESPONSE_PAYLOAD: response,
    },
    tags: {
      ERROR_TYPE: 'API_ERROR',
    },
  });
}



// WEBPACK FOOTER //
// ./src/utils/http-error.js